import { useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { NotificationSuccess } from "../../assets/icons/NotificationSuccess";

export interface IToastNotificationProps {
  message: string;
  type: "success" | "info" | "warning" | "error";
  // eslint-disable-next-line react/no-unused-prop-types
  width?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  rightMargin?: string;
}

export function ToastNotification({ message, type }: IToastNotificationProps) {
  const notificationStyle = {
    minHeight: "50px",
    backgroundColor: "#212121",
    borderRadius: "8px",
    color: "#FFFFFF",
    paddingLeft: "15px",
    paddingRight: "15px",
    fontFamily: '"Open Sans", sans-serif',
    zIndex: 3100,
  };

  useEffect(() => {
    switch (type) {
      case "success":
        toast.success(message, {
          style: notificationStyle,
          icon: NotificationSuccess,
        });
        break;
      case "info":
        toast.info(message, { style: notificationStyle });
        break;
      case "warning":
        toast.warn(message, { style: notificationStyle });
        break;
      case "error":
        toast.error(message, { style: notificationStyle });
        break;
      default:
        break;
    }
  }, [type, message]);

  return null;
}
